<div class="network-dialog">
  <header class="network-dialog__header">
    <div class="network-dialog__badge" aria-hidden="true">
      <i class="material-icons">lan</i>
    </div>
    <div class="network-dialog__heading">
      <h2 class="network-dialog__title">Network access</h2>
      <p class="network-dialog__subtitle">{{ location.location.name }}</p>
    </div>
    <button
      type="button"
      mat-icon-button
      class="network-dialog__close"
      (click)="dialogRef.close()"
      aria-label="Close"
    >
      <i class="material-icons">close</i>
    </button>
  </header>

  <div class="network-dialog__body" *ngIf="!isLoading">
    <form
      [formGroup]="addNetworkConfigFormGroup"
      class="network-add"
      (ngSubmit)="submitAddNetworkConfigForm()"
    >
      <p class="network-add__title">Add a network</p>
      <div class="network-add__fields">
        <mat-form-field appearance="outline" class="network-field network-field--ip">
          <mat-label>IP address</mat-label>
          <input type="text" [formControl]="ip" matInput placeholder="192.168.1.1" />
          <mat-error *ngIf="ValidationHelperService.isInvalid(ip)">
            {{ ValidationHelperService.getErrorMessage(ip) }}
          </mat-error>
        </mat-form-field>

        <span class="network-separator" aria-hidden="true">/</span>

        <mat-form-field appearance="outline" class="network-field network-field--mask">
          <mat-label>Subnet mask</mat-label>
          <input matInput [formControl]="mask" placeholder="24" />
          <mat-error *ngIf="ValidationHelperService.isInvalid(mask)">
            {{ ValidationHelperService.getErrorMessage(mask) }}
          </mat-error>
        </mat-form-field>

        <button
          mat-flat-button
          color="primary"
          type="submit"
          class="network-add__submit"
          [disabled]="ValidationHelperService.isInvalid(addNetworkConfigFormGroup)"
        >
          <i class="material-icons">add</i>
          <span>Add</span>
        </button>
      </div>
    </form>

    <div class="network-list">
      <p class="network-list__title" *ngIf="networkConfigsFormArray.controls.length">
        Allowed networks
        <span class="network-list__count">
          {{ networkConfigsFormArray.controls.length }}
        </span>
      </p>

      <div
        class="network-row"
        *ngFor="let networkConfig of networkConfigsFormArray.controls; let i = index"
        [class.network-row--editing]="getNetworkConfigIp(networkConfig).enabled"
      >
        <form
          class="network-row__form"
          [formGroup]="getNetworkConfigFormGroup(networkConfig)"
        >
          <ng-container *ngIf="getNetworkConfigIp(networkConfig).disabled">
            <div class="network-row__value">
              <i class="material-icons network-row__icon">router</i>
              <span class="network-address">
                {{ getNetworkConfigIp(networkConfig).value }}
                <span class="network-address__mask">
                  / {{ getNetworkConfigMask(networkConfig).value }}
                </span>
              </span>
            </div>

            <div class="network-row__actions">
              <button
                mat-icon-button
                type="button"
                class="network-action"
                (click)="
                  getNetworkConfigIp(networkConfig).enable();
                  getNetworkConfigMask(networkConfig).enable();
                  formGroupCached[networkConfig.value.id] = networkConfig.value
                "
                matTooltip="Edit network"
              >
                <i class="material-icons">edit</i>
              </button>
              <button
                mat-icon-button
                type="button"
                class="network-action network-action--danger"
                (click)="openConfirmationModal(networkConfig)"
                matTooltip="Remove network"
              >
                <i class="material-icons">delete_outline</i>
              </button>
            </div>
          </ng-container>

          <ng-container *ngIf="getNetworkConfigIp(networkConfig).enabled">
            <div class="network-row__fields">
              <mat-form-field appearance="outline" class="network-field network-field--ip">
                <mat-label>IP address</mat-label>
                <input
                  type="text"
                  [formControl]="getNetworkConfigIp(networkConfig)"
                  matInput
                />
                <mat-error
                  *ngIf="ValidationHelperService.isInvalid(getNetworkConfigIp(networkConfig))"
                >
                  {{ ValidationHelperService.getErrorMessage(getNetworkConfigIp(networkConfig)) }}
                </mat-error>
              </mat-form-field>

              <span class="network-separator" aria-hidden="true">/</span>

              <mat-form-field appearance="outline" class="network-field network-field--mask">
                <mat-label>Subnet mask</mat-label>
                <input
                  matInput
                  type="text"
                  [formControl]="getNetworkConfigMask(networkConfig)"
                />
                <mat-error
                  *ngIf="ValidationHelperService.isInvalid(getNetworkConfigMask(networkConfig))"
                >
                  {{ ValidationHelperService.getErrorMessage(getNetworkConfigMask(networkConfig)) }}
                </mat-error>
              </mat-form-field>
            </div>

            <div class="network-row__actions">
              <button
                mat-button
                type="button"
                class="network-cancel"
                (click)="
                  networkConfig.patchValue(formGroupCached[networkConfig.value.id], {});
                  getNetworkConfigIp(networkConfig).disable();
                  getNetworkConfigMask(networkConfig).disable()
                "
              >
                Cancel
              </button>
              <button
                mat-flat-button
                color="primary"
                type="button"
                class="network-save"
                [disabled]="
                  ValidationHelperService.isInvalid(getNetworkConfigFormGroup(networkConfig))
                "
                (click)="
                  submitEditNetworkConfigForm(networkConfig);
                  getNetworkConfigIp(networkConfig).disable();
                  getNetworkConfigMask(networkConfig).disable()
                "
              >
                Save
              </button>
            </div>
          </ng-container>
        </form>
      </div>

      <div class="network-empty" *ngIf="!networkConfigsFormArray.controls.length">
        <i class="material-icons network-empty__icon">wifi_tethering</i>
        <p class="network-empty__title">No networks added yet</p>
        <p class="network-empty__text">
          Add an IP address and subnet mask above to start restricting this
          location.
        </p>
      </div>
    </div>
  </div>

  <div class="network-dialog__loading" *ngIf="isLoading">
    <mat-spinner diameter="42"></mat-spinner>
  </div>

  <footer class="network-dialog__footer">
    <button mat-flat-button color="primary" class="network-done" (click)="dialogRef.close()">
      Done
    </button>
  </footer>
</div>
